import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { formatCurrency } from "utils/tools"

export interface ExpenseBudgetChartPoint {
    month: string
    planned: number
    // Acumatica bills linked to the products; null for months with nothing billed yet.
    billed: number | null
    // GL actuals of the cost code accounts; null for months not closed yet.
    actual?: number | null
}

interface ExpenseBudgetChartProps {
    data: ExpenseBudgetChartPoint[]
    // Adds the GL actual bars (only for the whole budget: the GL can't be split by product).
    showActual?: boolean
}

// Monthly plan vs linked bills, and optionally vs GL actuals.
const ExpenseBudgetChart = ({ data, showActual }: ExpenseBudgetChartProps) => (
    <div style={{ width: "100%", height: 360 }}>
        <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ right: 10, left: 40, bottom: 10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis tickFormatter={(v: number) => formatCurrency(v, "CAD", 0)} />
                <Tooltip formatter={(v: number) => formatCurrency(v)} />
                <Legend />
                <Bar dataKey="planned" name="Plan" fill="var(--bs-primary)" />
                <Bar dataKey="billed" name="Billed (linked bills)" fill="var(--bs-success)" />
                {showActual && <Bar dataKey="actual" name="GL actual (closed months)" fill="var(--bs-warning)" />}
            </BarChart>
        </ResponsiveContainer>
    </div>
)

export default ExpenseBudgetChart
